export default {"src":"/_next/static/media/card-amex.d1ad571d.svg","height":16,"width":24,"blurWidth":0,"blurHeight":0};